/**
 * Contains the default options
 * @type {{offset: number, speed: number}}
 */
const defaultOptions = {
    speed: 800,
    offset: 0,
    events: {
        beforeAnimate() {},
        afterAnimate() {}
    }
};

/**
 * Handles scrolling to elements smoothly.
 * @author Jeroen Wallbrink
 * @param el
 * @param options
 * @constructor
 */
export default function SmoothAnchorScroller(el, inputOptions) {

    /**
     * Merge the default options with the given Options
     */
    const options = {};
    jQuery.extend(true, options, defaultOptions, inputOptions)

    /**
     * Select al matching Elements
     * @type {jQuery.fn.init|*|jQuery|HTMLElement}
     */
    el = $(el);

    el.on('click', (e) => {

        e.preventDefault()

        let clickedElement = $(e.currentTarget)
        let hash = clickedElement.attr('href')

        if(hash.length < 2 || hash.substring(0,1) !== '#')
            return;

        options.events.beforeAnimate()

        $('html, body').animate({
            scrollTop: $(hash).offset().top - options.offset
        }, options.speed, function () {
            window.location.hash = hash
            options.events.afterAnimate()
        })

    })

    return this;
}